import {get as _get} from 'lodash';

import {UTR_MEN, UTR_WOMEN} from '@constants/variables';
import {convertToInt} from '@utils/helpers';

export const shouldSkipEventPvHistory = (event) => {
    if (!event) {
        return true;
    }

    const tournamentCategoryId = _get(event, 'sr_event.tournament.tournament_category.id', null);

    return !(
        convertToInt(UTR_WOMEN) === convertToInt(tournamentCategoryId)
        || convertToInt(UTR_MEN) === convertToInt(tournamentCategoryId)
    );
};
